<template>
  <v-dialog v-model="dialog" width="850">
    <template v-slot:activator="{}">
      <BaseButton
        @click="openModal"
        :text="
          localStorage.translations.pages.personnel_department.dialog_addemployee_buttons[
            'dobavit-sotrudnika'
          ]
        "
        default_icon="button-add"
      />
    </template>
    <EmployeesCreateModalList v-if="dialog" :closeModal="closeModal" />
  </v-dialog>
</template>

<script>
import EmployeesCreateModalList from 'components/employees/EmployeesCreateModalList'
export default {
  name: 'EmployeesCreateModal',
  props: ['toName'],
  components: { EmployeesCreateModalList },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>
